var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback } from "react";
import styled from "styled-components";
import moment from "moment";
import { InputDate } from "./InputDate";
import { InputTime } from "./InputTime";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex !important;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  & > div {\n    width: calc(50% - 10px);\n  }\n"], ["\n  width: 100%;\n  display: flex !important;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  & > div {\n    width: calc(50% - 10px);\n  }\n"])));
export var InputDateTime = function (_a) {
    var selected = _a.selected, onChange = _a.onChange;
    var handleDateChange = useCallback(function (newDate) {
        var oldDate = moment(selected);
        var nextDate = moment(newDate);
        nextDate.hours(oldDate.hours());
        nextDate.minutes(oldDate.minutes());
        onChange(nextDate.toDate());
    }, [selected, onChange]);
    return (React.createElement(Container, null,
        React.createElement(InputDate, { selected: selected, onChange: handleDateChange }),
        React.createElement(InputTime, { selected: selected, onChange: onChange })));
};
var templateObject_1;
//# sourceMappingURL=InputDateTime.js.map